import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import desktop from "./assets/images/JS RDA.jpeg";
import RAClogo from "./assets/images/rac.png";
import "./assets/css/style.css";
import React, { useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import VehicleDetails from "./VehicleDetails";
import NomineeDetail from "./NomineeDetail";
import { Navigate, Outlet } from "react-router-dom";
import Footer from "./Footer";
import {
  alphabetRegex,
  limitRegex,
  setupProfile,
  finDetailObj,
  cnicRegex,
  fundDetails,
  defaultValue,
  nomineeDetail,
  emailRegex,
  mobileNumber,
  numeric,
} from "./utils";
import axios from "axios";
import {
  comboApiCollection,
  comboApiParam,
  FinalDataApi,
  lovsApi,
  postapiparam,
} from "./APIRequests";
import FinancingDetails from "./FinancingDetails";
import { useLocation } from "react-router-dom";
import { OTPModal } from "./Components/OTPModal";
import { Spinner } from "react-bootstrap";
import { ErrorModal } from "./Components/ErrorModal";
import { useNavigate } from "react-router-dom";
import { MD5 } from "crypto-js";
import { comboApis } from "./assets/js/comboAPIjson";

function StepperForm() {
  const [key, setKey] = useState(1);
  const [id, setId] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  let postapiparam = {
    apni_car_request_dto: {},
    bool_spare1_val: true,
    bool_spare2_val: true,
    bool_spare3_val: true,
    bool_spare4_val: true,
    bool_spare5_val: true,
    intSpare1Val: 0,
    intSpare2Val: 0,
    intSpare3Val: 0,
    intSpare4Val: 0,
    intSpare5Val: 0,
    module_id: "21",
    status_id: "string",
    str_spare1_val: "string",
    str_spare2_val: "string",
    str_spare3_val: "string",
    str_spare4_val: "string",
    str_spare5_val: "string",
    user: 0,
    user_role: "string",
  };

  //DropDown Data
  const [apiComboResponse, setApiComboResponse] = useState({
    City: [],
    Pricing_option: [],
    Financing_option: [],
    Financing_Tenure: [],
    Insurance_company: [],
    Vehicle_Make: [],
    Relationship: [],
    Percentage: [],
  });

  const [errorModal, setErrorModal] = useState({ show: false, message: "" });
  const handleClose = () => setErrorModal({ show: false, message: "" });

  const [trackingId, setTrackingId] = useState("");
  let obj = {
    //CNIC and Account Number from Auth Page
    setupProfile: {
      ...setupProfile,
      cnic_number: {
        value: location?.state?.auth?.cnic ? location?.state?.auth?.cnic : "",
      },
      account_number: {
        value: location?.state?.auth?.accountNo
          ? location?.state?.auth?.accountNo
          : "",
      },
    },
    finDetailObj: finDetailObj,
    nomineeDetail: {
      ...nomineeDetail,
      name: {
        ...nomineeDetail.name,
        value: location?.state?.auth?.name ? location?.state?.auth?.name : "",
      },
    },
    fundDetails: fundDetails,
  };

  const [formObj, setformObj] = useState(obj);
  const [loading, setloading] = useState(false);

  //Validation in index.js
  const checkvalidation = (objectkey) => {
    let formobjArray = Object.keys(formObj[objectkey]);
    let bool = [];
    formobjArray.forEach((obj, index) => {
      let item = formObj[objectkey][obj];

      if (item.type == "Alphabets") {
        if (!alphabetRegex(item.value)) {
          bool = bool = [...bool, !alphabetRegex(item.value)];
          setErrorModal({
            show: true,
            message: `Numbers or Characters are not allowed in ${obj
              .split("_")
              .join(" ")}`,
          });
          return bool;
        }
      }
      if (item.type == "Email") {
        if (!emailRegex(item.value)) {
          bool = bool = [...bool, !emailRegex(item.value)];
          alert(`Enter Valid Email in ${obj.split("_").join(" ")}`);
          return bool;
        }
      }
      if (item.type == "MobileNumber") {
        if (!mobileNumber(item.value)) {
          bool = bool = [...bool, !mobileNumber(item.value)];
          setErrorModal({
            show: true,
            message: `Enter Valid Mobile Number in ${obj.split("_").join(" ")}`,
          });
          return bool;
        }
      }
      if (item.type == "NumericWithHypen") {
        if (!cnicRegex(item.value)) {
          bool = bool = [...bool, !cnicRegex(item.value)];
          setErrorModal({
            show: true,
            message: `CNIC NO must be in this format : XXXXX-XXXXXXX-X in ${obj
              .split("_")
              .join(" ")}`,
          });
          return bool;
        }
      }
      if (item.type == "Numeric") {
        if (!numeric(item.value)) {
          bool = bool = [...bool, !numeric(item.value)];
          setErrorModal({
            show: true,
            message: `Numbers Allowed Only in ${obj.split("_").join(" ")}`,
          });
          return bool;
        }
      }
      if (item.limit) {
        if (!limitRegex(item.value, item?.min ? item.min : 1, item.limit)) {
          bool = bool = [
            ...bool,
            !limitRegex(item.value, item?.min ? item.min : 1, item.limit),
          ];
          let msg = item.min
            ? `${item.label} min limit is ${item.min} & max limit is ${item.limit}`
            : `${item.label} max limit is ${item.limit}`;
          alert(msg);
          return bool;
        }
      } else {
        bool = bool = [...bool, false];

        return bool;
      }
    });
    return bool.some((iteration) => iteration === true);
  };

  //Stepper Move Forward Event
  const continueStepEvent = (objectkey) => {
    let index = parseInt(key) + 1;
    if (index == 5) {
      if (
        location?.state?.auth?.cnic == defaultValue.cnic &&
        location?.state?.auth?.accountNo == defaultValue.accountNo
      ) {
        setKey(index);
      } else {
        setloading((isloading) => !isloading);
        let stepObject = Object.keys(formObj);
        stepObject.forEach((element) => {
          Object.keys(formObj[element]).forEach((keyItem) => {
            if (keyItem == "autoContribution") {
              postapiparam = {
                ...postapiparam,
                apni_car_request_dto: {
                  ...postapiparam.apni_car_request_dto,
                  [keyItem]: formObj[element][keyItem].value ? "Yes" : "No",
                },
              };
            } else {
              postapiparam = {
                ...postapiparam,
                apni_car_request_dto: {
                  ...postapiparam.apni_car_request_dto,
                  [keyItem]:
                    formObj[element][keyItem].type == "number"
                      ? parseInt(formObj[element][keyItem].value)
                      : formObj[element][keyItem].value,
                },
              };
            }
          });
        });
        const finalDtoPostHash = JSON.stringify(postapiparam);
        var finalPostHashHeader = MD5(finalDtoPostHash).toString();
        const header = {
          logToken: finalPostHashHeader,
        };
        axios
          .post(
            FinalDataApi,
            postapiparam
            //   , {
            //   headers: header,
            // }
          )
          .then((res) => {
            if (res.status == 200) {
              setloading((isloading) => !isloading);
              if (res.data.message === "Succsess") {
                setTrackingId(res.data?.body?.strSpare2Val);
                window.localStorage.removeItem("auth");
                setKey(index);
              } else {
                setErrorModal({ show: true, message: "Something went wrong." });
                // setKey(index);
              }
            } else {
              setErrorModal({ show: true, message: "Han Jani, Infosec?" });
            }
          })
          .catch((err) => {
            if (
              err.response?.status === 1000 &&
              err.response?.data?.message ===
                "IllegalArgumentException: Last unit does not have enough valid bits"
            ) {
              setErrorModal({
                show: true,
                message: "Unauthorized",
              });
            } else if (err.response?.status === 403) {
              setErrorModal({
                show: true,
                message: "Forbidden",
              });
            } else if (err.response?.status === 429) {
              setErrorModal({
                show: true,
                message: "Too many request",
              });
            } else if (err.response?.status === 99) {
              setErrorModal({
                show: true,
                message: "Something went wrong",
              });
            } else {
              setErrorModal({
                show: true,
                message: "Something went wrong",
              });
            }
            setloading((isloading) => !isloading);
          });
      }
    } else {
      if (checkvalidation(objectkey)) {
      } else {
        setKey(index);
      }
    }
  };

  const responseHash = (respData, respHeader) => {
    const bodyToString = JSON.stringify(respData);
    var respBodyHash = MD5(bodyToString).toString();
    return respBodyHash === respHeader ? true : false;
  };

  //Stepper Move Bacwards Event
  const backStepEvent = () => {
    let index = parseInt(key) - 1;
    setKey(index);
  };

  //Incremental fill Object for Final Data
  const handleChange = (e, object, key) => {
    setformObj({
      ...formObj,
      [object]: {
        ...formObj[object],
        [key]: {
          ...formObj[object][key],
          value: e.target?.files
            ? e.target.files[0]
            : e?.target?.type === "checkbox"
            ? e.target.checked
            : e.target.value,
        },
      },
    });
  };

  //Set DropDowns
  const comboApiEvent = async () => {
    let resp = apiComboResponse;

    for (const iterator of lovsApi) {
      await axios
        .post(comboApiCollection, {
          channel: "101",
          lovs_type: iterator,
          module_id: "21",
        })
        .then((Response) => {
          if (Response.data?.lovs_response_details?.lovList) {
            resp = {
              ...resp,
              [iterator]: Response.data?.lovs_response_details?.lovList,
            };
          }
        });
      setApiComboResponse(resp);
    }
  };

  window.localStorage.removeItem("auth");

  useEffect(() => {
    if (location?.state?.auth?.accountNo == null || undefined) {
      navigate("/");
    }
  }, [apiComboResponse]);

  useEffect(() => {
    // comboApiEvent();
    setApiComboResponse(comboApis);
  }, []);

  return (
    <div>
      <header>
        <div className="header">
          <div className="d-flex justify-content-between align-items-center headerlogw">
            {/* <div className="logo">
              <img src={h1} alt="" />
            </div> */}

            <div className="logo">
              <img src={desktop} alt="" />
            </div>

            <div className="logo car-logo">
              <img src={RAClogo} alt="" />
            </div>
          </div>
          <div className="wizard">
            <div className="wizard-inner container">
              <div className="connecting-line"></div>

              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                // onSelect={(k) => setKey(k)}
                className="mb-3"
              >
                <Tab
                  eventKey={1}
                  title={
                    <>
                      <span className="tab-title">Financing Details</span>
                      <span className="round-tab">1</span>
                    </>
                  }
                >
                  <FinancingDetails
                    formObj={formObj}
                    handleChange={handleChange}
                    backStepEvent={backStepEvent}
                    continueStepEvent={continueStepEvent}
                    comboResponse={apiComboResponse}
                  />
                </Tab>

                <Tab
                  eventKey={2}
                  title={
                    <>
                      <span className="tab-title">Vehicle Details</span>
                      <span className="round-tab">2 </span>
                    </>
                  }
                >
                  <VehicleDetails
                    formObj={formObj}
                    handleChange={handleChange}
                    backStepEvent={backStepEvent}
                    continueStepEvent={continueStepEvent}
                    comboResponse={apiComboResponse}
                  />
                </Tab>

                <Tab
                  eventKey={3}
                  title={
                    <>
                      <span className="tab-title">Nominee Details</span>
                      <span className="round-tab">3</span>
                    </>
                  }
                >
                  <NomineeDetail
                    formObj={formObj}
                    handleChange={handleChange}
                    backStepEvent={backStepEvent}
                    continueStepEvent={continueStepEvent}
                    comboResponse={apiComboResponse}
                  />
                </Tab>

                <Tab
                  eventKey={4}
                  title={
                    <>
                      <span className="tab-title">Preview</span>
                      <span className="round-tab">4</span>
                    </>
                  }
                >
                  <div className="tab-pane" role="tabpanel" id="step8">
                    <h4 className="text-center">Review From and Submit</h4>
                    <Accordion>
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>Financing Details</Accordion.Header>
                        <Accordion.Body>
                          <FinancingDetails
                            formObj={formObj}
                            handleChange={handleChange}
                            backStepEvent={backStepEvent}
                            continueStepEvent={continueStepEvent}
                            isPreview={true}
                            comboResponse={apiComboResponse}
                          />
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="1">
                        <Accordion.Header>Vehicle Details</Accordion.Header>
                        <Accordion.Body>
                          <VehicleDetails
                            formObj={formObj}
                            handleChange={handleChange}
                            backStepEvent={backStepEvent}
                            continueStepEvent={continueStepEvent}
                            comboResponse={apiComboResponse}
                            isPreview={true}
                          />
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="3">
                        <Accordion.Header>Nominee Detail</Accordion.Header>
                        <Accordion.Body>
                          <NomineeDetail
                            formObj={formObj}
                            handleChange={handleChange}
                            backStepEvent={backStepEvent}
                            continueStepEvent={continueStepEvent}
                            isPreview={true}
                            comboResponse={apiComboResponse}
                          />
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                    <ul className="list-inline pull-right">
                      <li>
                        <button
                          type="button"
                          className="default-btn prev-step"
                          onClick={backStepEvent}
                          disabled={loading ? true : false}
                        >
                          Back
                        </button>
                      </li>
                      <li>
                        {/* <button
                          type="button"
                          className="default-btn next-step skip-btn"
                          onClick={continueStepEvent}
                        >
                          Skip
                        </button> */}
                      </li>
                      <li>
                        <button
                          type="button"
                          className="default-btn next-step loader-btn"
                          onClick={continueStepEvent}
                          disabled={loading ? true : false}
                        >
                          Submit{" "}
                          {loading ? (
                            <Spinner
                              animation="border"
                              role="status"
                              variant="light"
                            ></Spinner>
                          ) : (
                            ""
                          )}
                        </button>
                      </li>
                    </ul>
                  </div>
                </Tab>

                <Tab
                  eventKey={5}
                  title={
                    <>
                      <span className="tab-title">Finish</span>
                      <span className="round-tab">5</span>
                    </>
                  }
                >
                  <div className="tab-pane" role="tabpanel" id="step9">
                    <div className="row justify-content-center">
                      <div className="col-lg-8">
                        <h4
                          className="text-center"
                          style={{ fontWeight: "bold" }}
                        >
                          Thank you For Your Interest in Roshan Apni Car
                        </h4>
                        <p
                          style={{
                            fontSize: "15px",
                            textAlign: "center",
                            fontWeight: "bold",
                          }}
                        >
                          Thank you for choosing JS Bank. {id} Your Roshan Apni
                          Car request has been submitted. Your tracking id is{" "}
                          <b>{trackingId}</b>. You will be notified within 48
                          hours.
                        </p>
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </header>
      <Footer />

      <ErrorModal modalProps={errorModal} handleClose={handleClose} />
    </div>
  );
}

const temp = () => {
  var VariableTemp = "casd";
};

export default StepperForm;
